'use client'

import {
  countryListWithFlags,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui'
import { ControllerRenderProps } from 'react-hook-form'

import { cn } from '../lib'

export const CountrySelect = (
  field: ControllerRenderProps & {
    className?: string
  },
) => {
  return (
    <Select onValueChange={field.onChange} value={field.value}>
      <SelectTrigger className={cn('w-full')}>
        <SelectValue placeholder="Country" />
      </SelectTrigger>
      <SelectContent>
        {countryListWithFlags.map(country => (
          <SelectItem key={country.name} value={country.code}>
            <div className="flex items-center gap-2">
              <span>{country.label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default CountrySelect
